import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerServiceWorker } from './pwa';
import { App } from './App';
import { initDebugUnlock } from './services/debugUnlock';
import './styles.css';

// `?debugUnlock=1` / `=0` を localStorage に反映してから描画する(services/debugUnlock.ts)。
initDebugUnlock();

const container = document.getElementById('root');
if (!container) {
  throw new Error('#root element not found');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// オフラインでも遊べるようにする(docs/03_architecture.md §1)。
registerServiceWorker();
